var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '18px',
'height': '19px',
'viewBox': '0 0 18 19',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45.2 (43514) - http://www.bohemiancoding.com/sketch --> <title>icons/report-bar copy</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"SUPER-ADMIN\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" opacity=\"0.699999988\"> <g id=\"A.-5.3-INTERIM-CANDIATE-FILTER\" transform=\"translate(-1174.000000, -557.000000)\" fill=\"#757575\"> <g id=\"Candidate-List-View\" transform=\"translate(60.000000, 383.000000)\"> <g id=\"Candidates\" transform=\"translate(0.000000, 0.951660)\"> <g id=\"Candidates---List-View\" transform=\"translate(0.000000, 34.000000)\"> <g id=\"Group-2-Copy\" transform=\"translate(927.666667, 137.000000)\"> <g id=\"icons/view/report\" transform=\"translate(181.000000, 2.000000)\"> <g id=\"bar\" transform=\"translate(5.754885, 0.000000)\"> <path d=\"M12.1671169,0 L12.1671169,18.2506754 L17.4902306,18.2506754 L17.4902306,0 L12.1671169,0 Z M6.08355846,5.32311365 L6.08355846,18.2506754 L11.4066721,18.2506754 L11.4066721,5.32311365 L6.08355846,5.32311365 Z M7.60444807,6.84400326 L9.88578249,6.84400326 L9.88578249,16.7297858 L7.60444807,16.7297858 L7.60444807,6.84400326 Z M0,10.6462273 L0,18.2506754 L5.32311365,18.2506754 L5.32311365,10.6462273 L0,10.6462273 Z\" id=\"Shape\" fill-rule=\"nonzero\"></path> </g> </g> </g> </g> </g> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./src/app/assets/report-bar copy.svg